import React, { FunctionComponent } from "react";

const InlineCode: FunctionComponent<React.PropsWithChildren> = ({
  children,
}) => (
  <code className="text-xs border rounded border-border bg-muted text-oso-fact-red dark:text-red-400 px-1 py-0.5">
    {children}
  </code>
);

export default InlineCode;
